import { Button } from "@/components/ui/button";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Pencil, Trash2, Package } from "lucide-react";
import { Link } from "react-router-dom";

// Lista de rotas (Iter 98): bolinha de cor + nome · bairros · status · ações.
export function RotasTable({ rotas, bairroName, canEdit, canDelete, onEdit, onDelete, onToggleAtiva, loading, entregasHref }) {
  const bairrosLabel = (ids) => {
    const nomes = (ids || []).map((id) => bairroName[id]).filter(Boolean);
    if (nomes.length === 0) return <span className="text-slate-400 text-xs">Nenhum bairro</span>;
    const shown = nomes.slice(0, 3).join(", ");
    return <span className="text-xs text-slate-600" title={nomes.join(", ")}>{shown}{nomes.length > 3 ? ` +${nomes.length - 3}` : ""}</span>;
  };
  return (
    <Table>
      <TableHeader><TableRow>
        <TableHead>Rota</TableHead>
        <TableHead className="w-28 text-center">Bairros</TableHead>
        <TableHead>Quais</TableHead>
        <TableHead className="w-28">Status</TableHead>
        <TableHead className="w-24">Ações</TableHead>
      </TableRow></TableHeader>
      <TableBody>
        {rotas.map((r) => (
          <TableRow key={r.id} data-testid={`rota-row-${r.id}`}>
            <TableCell>
              <div className="flex items-center gap-2">
                <span className="w-4 h-4 rounded-full shrink-0 border border-white shadow" style={{ backgroundColor: r.cor }} data-testid={`rota-dot-${r.id}`} title={r.cor} />
                <span className="font-medium" data-testid={`rota-nome-${r.id}`}>{r.nome}</span>
              </div>
            </TableCell>
            <TableCell className="text-center">
              <span className="inline-flex items-center justify-center min-w-[28px] rounded-full bg-slate-100 text-slate-700 text-xs font-bold px-2 py-0.5" data-testid={`rota-bairros-count-${r.id}`}>
                {r.bairros_count ?? (r.bairro_ids || []).length}
              </span>
            </TableCell>
            <TableCell>{bairrosLabel(r.bairro_ids)}</TableCell>
            <TableCell>
              <button type="button" onClick={() => canEdit && onToggleAtiva(r)} disabled={!canEdit}
                data-testid={`rota-status-${r.id}`} data-active={r.ativa !== false}
                title={canEdit ? "Clique para alternar" : ""}
                className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-[11px] font-bold uppercase border transition-colors ${r.ativa !== false ? "bg-emerald-50 text-emerald-700 border-emerald-200 hover:bg-emerald-100" : "bg-slate-100 text-slate-500 border-slate-200 hover:bg-slate-200"} ${canEdit ? "cursor-pointer" : "cursor-default"}`}>
                <span className={`w-1.5 h-1.5 rounded-full ${r.ativa !== false ? "bg-emerald-500" : "bg-slate-400"}`} />
                {r.ativa !== false ? "Ativa" : "Inativa"}
              </button>
            </TableCell>
            <TableCell>
              <div className="flex gap-1">
                {entregasHref && (
                  <Button size="icon" variant="ghost" asChild title="Ver entregas desta rota" data-testid={`rota-entregas-${r.id}`}>
                    <Link to={entregasHref(r)}><Package className="w-4 h-4 text-slate-600" /></Link>
                  </Button>
                )}
                {canEdit && <Button size="icon" variant="ghost" onClick={() => onEdit(r)} data-testid={`rota-edit-${r.id}`} title="Editar"><Pencil className="w-4 h-4 text-orange-600" /></Button>}
                {canDelete && <Button size="icon" variant="ghost" onClick={() => onDelete(r)} data-testid={`rota-delete-${r.id}`} title="Excluir"><Trash2 className="w-4 h-4 text-rose-600" /></Button>}
              </div>
            </TableCell>
          </TableRow>
        ))}
        {rotas.length === 0 && (
          <TableRow><TableCell colSpan={5} className="text-center text-muted-foreground py-10" data-testid="rotas-empty">
            {loading ? "Carregando…" : "Nenhuma rota cadastrada. Clique em \"Nova Rota\" para começar."}
          </TableCell></TableRow>
        )}
      </TableBody>
    </Table>
  );
}
